import React from 'react'
import { useState,useEffect } from 'react'
import MasonryLayout from './MasonryLayout'
import { client } from '../client'
import Spinner from './Spinner'
import { feedQuery,searchQuery } from '../utils/data'
const Search = ({searchTerm,setSearchTerm}) => {

  const [pins, setpins] = useState(null)
  const [loading, setloading] = useState(false)
  
  useEffect(() => {
    setloading(true)
    if (searchTerm) {
      const q = searchQuery(searchTerm)
      client.fetch(q)
      .then((data)=>{
        setloading(false)
        setpins(data)
      
      })
     
    } else{
      const q = feedQuery
      client.fetch(q)
      .then((data)=>{
        setpins(data)

      })
     setloading(false)   
    }
  }, [searchTerm])
  

  return (
    <div>
      {loading && <Spinner message={"Searching For Pins."}/>}
      {pins?.length!==0 && <MasonryLayout pins={pins} />}
      {pins?.length===0 && searchTerm!=="" && loading && (
        <div className='mt-10 text-xl text-center'>
          No Pins Found!
        </div>
      )}
    </div>
  )
}

export default Search